import React, {useEffect, useState} from 'react'
import {ActivityArea} from '../../common/types/activityArea'
import {SearchOrCreateDropdown} from '../../webui/inputs/SearchOrCreateDropdown'
import {useAllActivityAreas} from './gql/useActivityAreas'

interface Props {
  onChange: (value: string) => void
  value?: string | undefined
}

const getUniqueAreaInfos = (activityAreas: ActivityArea[]): string[] => {
  return Array.from(
    new Set(
      activityAreas
        .flatMap((activityArea) => activityArea.areaInfos)
        .map((areaInfo) => areaInfo.type)
        .filter((areaInfoType) => Boolean(areaInfoType)),
    ),
  ).sort()
}

export const SelectOrCreateAreaInfoType: React.FC<Props> = ({onChange, value}) => {
  const {data: activityAreas} = useAllActivityAreas()
  const [options, setOptions] = useState<string[]>([])

  const handleChange = (newValue: string) => {
    onChange(newValue)
  }

  useEffect(() => {
    setOptions(getUniqueAreaInfos(activityAreas))
  }, [activityAreas])

  return (
    <div>
      <SearchOrCreateDropdown options={options} value={value} onChange={handleChange} placeholder="Select or type" label="Area info" />
    </div>
  )
}
